import { z } from 'zod';
import { PutRecyclingRequestRequestBody } from '@/src/apis/rest/recyclingRequests.dtos';

export const DEFAULT_VALUES: PutRecyclingRequestRequestBody = {
  nick: '',
  cancelReason: '',
  name: '',
};

export const formSchema = () => {
  return z.object({
    cancelReason: z.string().min(1, '수거 취소 사유를 입력해주세요.'),
  });
};

export const formFields = {
  nick: {
    name: 'nick',
    label: '닉네임',
  },
  administrator: {
    name: 'name',
    label: '담당 관리자',
  },
  cancelReason: {
    name: 'cancelReason',
    label: '수거 취소 사유',
    placeholder: '수거 상태를 취소하는 사유를 입력해주세요.',
  },
} as const;
